var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuZoneTrendOver(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "menu-zone-trend-over") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "menu-zone-trend-over"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,12 C0,18.6272846 5.37253977,24 12.0001132,24 C18.6274602,24 24,18.6272846 24,12 C24,5.37271544 18.6274602,0 12.0001132,0 C5.37253977,0 0,5.37271544 0,12",
    id: "Fill-1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M16.7368421,6 L7.26315789,6 C6.56842105,6 6,6.6 6,7.33333333 L6,16.6666667 C6,17.4 6.56842105,18 7.26315789,18 L16.7368421,18 C17.4315789,18 18,17.4 18,16.6666667 L18,7.33333333 C18,6.6 17.4315789,6 16.7368421,6 Z M7.26315789,16.7333333 L16.7368421,16.7333333 L16.7368421,7.33333333 L7.26315789,7.33333333 L7.26315789,16.7333333 Z M13.8947368,15.3333333 L15.1578947,15.3333333 L15.1578947,12.6666667 L13.8947368,12.6666667 L13.8947368,15.3333333 Z M11.3684211,15.3333333 L12.6315789,15.3333333 L12.6315789,8.66666667 L11.3684211,8.66666667 L11.3684211,15.3333333 Z M8.84210526,15.3333333 L10.1052632,15.3333333 L10.1052632,10.6666667 L8.84210526,10.6666667 L8.84210526,15.3333333 Z",
    id: "Page-1-Copy-2",
    fill: "#009846"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuZoneTrendOver);
export default __webpack_public_path__ + "static/media/menu-zone-trend-over.12cfd37289e9da364a3bdc7020c8da52.svg";
export { ForwardRef as ReactComponent };